import React from 'react'
import ReactDOM from 'react-dom/client'
import {EventSearch} from "./components/Event/EventSearch.jsx"
import {EventFilter} from "./components/Event/EventFilter.jsx"

const DEBUG = window.location.search.includes('debugEventSearch=1')

let filterRoot = null
let filterElementRef = null
let resultsRoot = null
let resultsElementRef = null

const debugLog = (message, payload = undefined) => {
    if (!DEBUG) {
        return
    }

    console.debug(`[event_search] ${message}`, payload)
}

const initFilter = () => {
    const element = document.querySelector('.solr-event-filter')

    if (element === null) {
        debugLog('filter container not found')
        return
    }

    if (filterRoot !== null && filterElementRef !== element) {
        filterRoot.unmount()
        filterRoot = null
    }

    if (filterRoot === null) {
        filterRoot = ReactDOM.createRoot(element)
        filterElementRef = element
    }

    filterRoot.render(
        React.createElement(React.StrictMode, null,
            React.createElement(EventFilter)
        )
    )

    debugLog('filter mounted')
}

const initResults = () => {
    const element = document.querySelector('.solr-event-results')

    if (element === null) {
        debugLog('results container not found')
        return
    }

    if (resultsRoot !== null && resultsElementRef !== element) {
        resultsRoot.unmount()
        resultsRoot = null
    }

    if (resultsRoot === null) {
        resultsRoot = ReactDOM.createRoot(element)
        resultsElementRef = element
    }

    resultsRoot.render(
        React.createElement(React.StrictMode, null,
            React.createElement(EventSearch)
        )
    )

    debugLog('results mounted')
}

const initEventSearch = () => {
    initFilter()
    initResults()
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEventSearch, {once: true})
} else {
    initEventSearch()
}

window.addEventListener('pageshow', (event) => {
    debugLog('pageshow', {persisted: event.persisted})
    initEventSearch()

    if (event.persisted) {
        document.dispatchEvent(new CustomEvent('event-search:restore', {
            detail: {source: 'pageshow'}
        }))
    }
})

window.addEventListener('popstate', () => {
    debugLog('popstate')
    window.setTimeout(() => {
        initEventSearch()
        document.dispatchEvent(new CustomEvent('event-search:restore', {
            detail: {source: 'popstate'}
        }))
    }, 0)
})

